export const eventConfig = {
  name: 'Obiettivo Medicina, Odontoiatria e Veterinaria',
  date: '2025-11-06',
  time: '11:00',
  duration: 60, // minutes
  location: 'Online',
  description: 'Partecipa al test!',
  day: 'giovedì',
  dateString: '6 novembre',
  timeString: '11:00',
  startUTC: '20251106T100000Z', 
  endUTC: '20251106T110000Z',  
  countdownStart: '2025-11-06T00:00:00+01:00',
  surveyUrl: 'https://it.surveymonkey.com/r/evento0611',
  liveUrl: '#',
};